import type { AttachmentView } from "../lib/attachments";
import { MessageAttachments } from "./MessageAttachments";

/**
 * A user turn: their words in a soft right-aligned bubble (the sans body — never
 * the display serif). No avatar or "who" label: the bubble shape says who is
 * speaking, so the layout reads as dialogue, not a document.
 */
export function UserMessage({
  content,
  attachments = [],
}: {
  content: string;
  attachments?: AttachmentView[];
}) {
  return (
    <div data-testid="user-message" className="flex flex-col items-end gap-2 py-2.5">
      <MessageAttachments views={attachments} />
      {content ? (
        <div className="max-w-[80%] whitespace-pre-wrap rounded-[20px] rounded-br-[6px] bg-bubble px-4 py-2.5 font-sans text-[15px] leading-[1.55] text-ink">
          {content}
        </div>
      ) : null}
    </div>
  );
}
